export const UPDATE_CURRENT_AOR_REQUEST = 'UPDATE_CURRENT_AOR_REQUEST'
export const UPDATE_CURRENT_AOR_SUCCESS = 'UPDATE_CURRENT_AOR_SUCCESS'
export const UPDATE_CURRENT_AOR_ERROR = 'UPDATE_CURRENT_AOR_ERROR'